import { ArticleFragmentFragment } from '../../__generated__/graphql';
import ArticleCard from '../../components/ArticleCard';
import Section from '../../layout/Section';
import SectionTitle from '../../layout/Section/SectionTitle';

import style from './news-and-insights.module.css';

interface NewsAndInsightsProps {
  articleLinkText: string;
  articles: ArticleFragmentFragment[];
  sectionId: null | string | undefined;
  sectionTitle?: null | string;
}

const NewsAndInsights = ({
  articleLinkText,
  articles,
  sectionId,
  sectionTitle,
}: NewsAndInsightsProps) => {
  return (
    <Section
      backgroundColor="white"
      id={sectionId}
      innerContainerClassName={style.newsAndInsights}
    >
      {sectionTitle && (
        <SectionTitle>
          {sectionTitle}
        </SectionTitle>
      )}

      <ul>
        {articles.map((article, index) => {
          return (
            <li key={article.id}>
              <ArticleCard
                article={article}
                articleLinkText={articleLinkText}
                size={index === 0 ? 'large' : 'small'}
              />
            </li>
          );
        })}
      </ul>
    </Section>
  );
};

export default NewsAndInsights;
